/**
 * Backend serializes Java `boolean isDefault` as JSON key "default" (Jackson/Lombok naming).
 * Normalize on read; send "default" on write.
 */

export function isPresetDefault(preset) {
  if (!preset) return false;
  return Boolean(preset.isDefault ?? preset.default);
}

export function normalizeSearchConfigFromApi(raw) {
  if (!raw || typeof raw !== 'object') return raw;
  return {
    ...raw,
    isDefault: isPresetDefault(raw),
  };
}

export function normalizeSearchConfigListFromApi(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeSearchConfigFromApi);
}

/** Payload for POST saveUserSearchPref — must use "default", not only "isDefault". */
export function toSearchConfigSavePayload(config) {
  if (!config || typeof config !== 'object') return config;
  const { isDefault, default: _ignored, ...rest } = config;
  return {
    ...rest,
    default: Boolean(isDefault ?? config.default),
  };
}
